import React from "react";
import { Link, NavLink } from "react-router-dom";
import { Fade } from "react-awesome-reveal";
import icon from "../../../images/icon/cross-x.svg";
import icon1 from "../../../images/icon/arrow-black.png";
import cImg from "../../../images/cta/massage-text01.png";
import cImg2 from "../../../images/cta/massage-text02.png";
import line from "../../../images/cta/color-line.jpg";

const CtaSection = (props) => {
  const ClickHandler = () => {
    window.scrollTo(10, 0);
  };

  return (
    <section
      className="cta pos-rel pt-70 pb-135"
      style={{ backgroundColor: "#f6f0e6" }}
    >
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-7">
            <div className="hd-cta text-center">
              <div className="sec-title--two sec-title--four">
                <Fade
                  direction="up"
                  triggerOnce={"false"}
                  duration={1000}
                  delay={9}
                >
                  <div>
                    <div
                      className="sub-title wow fadeInUp"
                      data-wow-duration="600ms"
                    >
                      Send Money with Confidence
                    </div>
                  </div>
                </Fade>
                <Fade
                  direction="up"
                  triggerOnce={"false"}
                  duration={1000}
                  delay={9}
                >
                  <div>
                    <h2
                      className="title wow fadeInUp"
                      data-wow-delay="150ms"
                      data-wow-duration="600ms"
                    >
                      Fast. Secure. Free. Anytime, Anywhere.
                    </h2>
                  </div>
                </Fade>
              </div>
              <Fade
                direction="up"
                triggerOnce={"false"}
                duration={1000}
                delay={9}
              >
                <div>
                  <div
                    className="xb-btn text-center mt-45 wow fadeInUp"
                    data-wow-delay="300ms"
                    data-wow-duration="600ms"
                  >
                    <NavLink
                      to="/download-buga-app"
                      rel="noopener noreferrer"
                      className="thm-btn thm-btn--three"
                    >
                      Send Money Now
                    </NavLink>
                    {/* <a
                      href="https://bugamoney.co.uk/app/app-login"
                      onClick={ClickHandler}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="thm-btn thm-btn--three"
                    >
                      Send Money Now
                    </a> */}
                  </div>
                </div>
              </Fade>
            </div>
          </div>
        </div>
      </div>
      <div className="hd-cta_shape">
        <div>
          <div
            className="shape shape--one wow fadeInLeft"
            data-wow-delay="000ms"
            data-wow-duration="600ms"
          >
            <img src={cImg} alt="" />
          </div>
        </div>
        <div>
          <div
            className="shape shape--two wow fadeInRight"
            data-wow-delay="100ms"
            data-wow-duration="600ms"
          >
            <img src={cImg2} className="" alt="" />
          </div>
        </div>
        <div>
          <div className="shape shape--three">
            <img src={line}  alt="" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default CtaSection;
